import script from "./CalendarIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarIcon.vue?vue&type=script&setup=true&lang=js"

import "./CalendarIcon.vue?vue&type=style&index=0&id=05e4e30a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05e4e30a"]])

export default __exports__